import { Content as BluBlocksContent } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled(BluBlocksContent)`
  align-items: start;
  display: grid;
`
